"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var WalletTabs = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var lang = (0, next_intl_1.useLocale)();
    var tabs = (0, react_1.useMemo)(function () { return [
        {
            link: "/".concat(lang, "/account/wallet/balance"),
            text: t('balance'),
        },
        {
            link: "/".concat(lang, "/account/wallet/deposit"),
            text: t('deposit'),
        },
        {
            link: "/".concat(lang, "/account/wallet/withdrawal"),
            text: t('withdrawal'),
        },
    ]; }, [lang, t]);
    return react_1.default.createElement(ui_components_1.Tabs, { tabs: tabs });
};
exports.default = WalletTabs;
